mainApp.directive('fadeOutOut', function() {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			element.on('mouseenter', function() {
				//logit("mouse enter")
				
				if (typeof jQuery == 'undefined') {  
				    // jQuery is not loaded
				    element.css({opacity:1})
				} else {
				    // jQuery is loaded
					element.fadeTo(75,1)
				}
			});

			element.on('mouseleave', function() {
				//logit("mouse leave")
				if (typeof jQuery == 'undefined') {  
				    // jQuery is not loaded
				    element.css({opacity:0.12})
				} else {
				    // jQuery is loaded
					element.fadeTo(400,0.12)
				}
			});
		}
	}
});

mainApp.directive('header', function() {
	return {
		restrict: 'A',
		templateUrl: './partials/header.html',
		link: function(scope, element, attrs) {
		}
	}
});